import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/post-layout.js";
import { HashLink } from '../components/link';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Where have all the mentors gone?`}</h1>
    <p>{`One of the most critical factors in my ability to become a proficient software developer was that I had some fantastic mentors along the way.`}</p>
    <p>{`Today, with the ubiquity of AI, it's even more important for junior engineers to have senior mentors.`}</p>
    <p>{`I've noticed that as I get more and more experienced in this industry, the pool of mentors more senior than me diminishes almost at an exponential rate. This seems fairly obvious in hindsight. Older folks are retiring, there is an influx of younger folks joining the market, and companies will only have so many staff+ level engineers. For me, the numbers are even lower since I prefer to work at startup companies with less headcount.`}</p>
    <p>{`Recently, I've come to another observation that gives me hope. There `}<em parentName="p">{`are`}</em>{` other mentorship opportunities for folks like me. When I really stop and think about it, I've learned so much from my mentees and from AI. The former may make more sense to most people than the latter but hear me out.`}</p>
    <h2><HashLink id="mentees" to="/mentors#mentees" mdxType="HashLink">{`The students become the teachers`}</HashLink></h2>
    <p>{`Teaching someone helps me learn the subject matter better. I can't just take for granted the implicit learnings I've built over the years. I need to break down the subject into clear, digestible lessons. I need to be able to answer, "Why?". Inevitably, this won't be the case for some subjects. This is where the real learning happens.`}</p>
    <p>{`A secondary source of learning comes directly from the mentee. No matter how "senior" you are you can always learn something new. There have been many instances where I learn a better way to do something by working with my mentees. This could be anything from a productivity tip for my IDE to something as nuanced as learning how they learn.`}</p>
    <p>{`We all learn this craft on our own journey. As I get further down the path it becomes more clear that the way folks are learning to build software is much different than how I learned. But my learning is never done.`}</p>
    <p>{`There are lessons in `}<em parentName="p">{`how`}</em>{` to learn in modern times.`}</p>
    <h2><HashLink id="ai-mentor" to="/mentors#ai-mentor" mdxType="HashLink">{`How can AI be a mentor?`}</HashLink></h2>
    <p>{`AI is a tool. The way I look at it is that it depends how you `}<em parentName="p">{`use`}</em>{` the tool.`}</p>
    <p>{`Some folks use AI to "get the answer".`}</p>
    <ul>
      <li parentName="ul">{`write my school essay`}</li>
      <li parentName="ul">{`build my program to have the output I expect`}</li>
      <li parentName="ul">{`do the math and tell me the solution`}</li>
    </ul>
    <p>{`Others, like myself, use AI to reduce the friction of curiosity.`}</p>
    <ul>
      <li parentName="ul">{`help me understand the structural issues in my first draft`}</li>
      <li parentName="ul">{`brainstorm a second or third architecture for my program`}</li>
      <li parentName="ul">{`show me how the math works`}</li>
    </ul>
    <p>{`I'd argue if you use AI to reduce the friction of curiosity and verify it's output then you have a seriously powerful "mentor".`}</p>
    <h2><HashLink id="conclusion" to="/mentors#conclusion" mdxType="HashLink">{`Parting thoughts`}</HashLink></h2>
    <p>{`Mentors are important in this business.`}</p>
    <p>{`There are more sources of mentorship available to all of us than most probably realize.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      